"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.isAppointmentTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "AppointmentTransactionDetails";
};
class AppointmentProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Appointment: () => `
        ... on Appointment {
          id
          providerId
          consumerId
          consumer {
            ${this.getFragment("UserPublicData")}
          }
          provider {
            ${this.getFragment("UserPublicData")}
          }
          title
          startTime
          endTime
          createTime
          active
          paid
          cost
        }
      `,
            AppointmentType: () => `
        ... on AppointmentType {
          id
          userId
          name
          duration
          cost
        }
      `,
            TransactionDetails: () => `
        ... on AppointmentTransactionDetails {
          appointmentId
        }
      `,
        };
    }
    search(data) {
        return this.query("appointmentSearch", { data }, this.getPageableFragment("Appointment"));
    }
    searchAppointmentTypes({ userId }) {
        return this.query("appointmentTypeSearch", { userId }, this.getFragment("AppointmentType"));
    }
    updateAppointmentTypes(data) {
        return this.mutate("appointmentTypeUpdate", { data }, this.getFragment("AppointmentType"));
    }
    payForAppointment({ id }) {
        return this.mutate("appointmentPay", { id }, this.getFragment("Appointment"));
    }
    subscribeToAppointment(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription {
            appointmentStarted {
              ${this.getFragment("Appointment")}
            }
          }
        `,
        }, data => {
            onData(data.appointmentStarted);
        }, onError);
    }
}
exports.AppointmentProvider = AppointmentProvider;
//# sourceMappingURL=AppointmentProvider.js.map